import { useAccounts } from "@/features/accounts/hooks/useAccounts";

export const DEFAULT_CURRENCY = "XOF";

/** Organisations run a single currency, so the first account decides it. */
export function useCurrency() {
  const { accounts, isLoading, error } = useAccounts();

  return {
    currency: accounts[0]?.currency ?? DEFAULT_CURRENCY,
    isLoading,
    error,
  };
}
